import React from 'react';
import classNames from 'classnames';

const PageHeaderActions = ({ children }) => (
  <div className={classNames('c-page__header-actions')}>{children}</div>
);

export default PageHeaderActions;
